module.exports = __webpack_public_path__ + "static/img/iSmartBI-icon.f16773e4.png";